import Vue from 'vue'
import protocolandrules from './protocolandrules.vue'
import router from './router'
import { Dialog,Toast,Swipe,SwipeItem } from 'vant';
import 'vant/lib/index.css';
import http from '@/api/http'
Vue.use(http)
Vue.use(Dialog,Toast);
Vue.use(Swipe).use(SwipeItem);
Vue.use(require('vue-wechat-title'))

new Vue({
    router,
    render: h => h(protocolandrules)
}).$mount('#protocolandrules')